import React, {useEffect, useState} from 'react';
import Footer from "../../components/Footer"
import Steps from "./Stage";
import {useFetching} from "../../hooks/useFetching"
import {API_SOLUTIONS_CASINO_SECOND_SECTION_SECURITY} from "../../utils/consts";
import ApiSolutionsCasinoSecondSectionSecurity from "../../services/SolutionsCasino/SecondSectionSecurity";
import {useLocation} from "react-router-dom";
import parse from "html-react-parser";
import {observer} from "mobx-react-lite";

import telegram from '../../img/telegram.png'

const SecondSection = ({marginY}) => {
    const location = useLocation()
    const [isLoading, setIsLoading] = useState(true);

    const [security, setSecurity] = useState();
    // const [security, setSecurity] = useState({name: 'Гарантії безпечної гри для відвідувачів та оператора', content: '<p>Система використовує захищені протоколи асинхронного шифрування та віддалений генератор випадкових чисел, цим самим забезпечуючи неможливість підміни результату гри, впливу на будь-які ігрові та операційні показники.</p>', contacts_ukraine: '<p>Контактні дані:</p> <p>ukraine@champion.tm</p>'});

    const [FunctionApiSolutionsCasinoSecondSectionSecurity] = useFetching(async () => {
        try {
            const response = await ApiSolutionsCasinoSecondSectionSecurity.getApiSolutionsCasinoSecondSectionSecurity(API_SOLUTIONS_CASINO_SECOND_SECTION_SECURITY);
            setSecurity(response.data);
        } catch {
            console.error('getApiSolutionsCasinoSecondSectionSecurity')
        }
    });

    useEffect(() => {
        if (!isLoading) {
            FunctionApiSolutionsCasinoSecondSectionSecurity();
        }
    }, [location.pathname, isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="section" id="section1" style={{marginTop: marginY}}>
            <div className="new_games" id="to">
                <div className="row">
                    <Steps setIsLoading={setIsLoading}/>
                    {security ? <>
                        <div className="security">
                            {security.name ? <h2>{security.name}</h2> : null}
                            {security.content ? parse(security.content) : null}
                        </div>
                        {security.contacts_ukraine ? <div className="contacts">
                            <div className="contacts_block">
                                <div className="location">
                                    <div className="telegram">
                                        <img src={telegram} alt="telegram"/>
                                        {parse(security.contacts_ukraine)}
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                    </> : null}
                </div>
            </div>
            <Footer/>
        </div>

    );
};

export default observer(SecondSection);